import labelManage from './labelManage'
export default labelManage
